import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import './style.scss';

/**
 * EndNode:
 *  - Component to display EndNode Components
 *    They are the Last Node in DesignViewOne, DesignViewTwo, DesignViewThree & DesignViewFour;
 *    They house a HexagonImage
 */
export function EndNode(props) {
  const renderNode = (c) => {
    return React.createElement(props.imageNode, {
      key: c.id,
      src: c.image,
      alt: "",
      ...props.imageNode.props,
    });
  };

  return (
    <div className='design-view__endNode'>
      {props.nodeComponents.map(renderNode)}
    </div>
  );
}

EndNode.propTypes = {
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of component
       */
      id: PropTypes.number,
      /**
       * Image URL for OutcomeNode
       */
      image: PropTypes.string,
    })
  ),
  /**
   * React Component to use as Component
   */
  imageNode: PropTypes.elementType,
};

EndNode.defaultProps = {
  nodeComponents: [],
};
